export default {
  folder: {
    name: 'String',
  },
  file: {
    folder_id: 'Number',
    name: 'String',
    file_date: 'base64',
  },
  edit_file: {
    folder_id: 'Number',
    name: 'String',
  },
}
